import { request } from "@/utilities/libs/request.ts";
import {
  IRequestArgs,
  IResponseData,
  ListResponseData,
} from "@/utilities/types/requests.ts";
import { ERequestMethods } from "@/utilities/enums/RequestMethod.ts";
import {
  EPromotionStatus,
  ICreatePromotionDTO,
  IPromotion,
  IPromotionDTO,
} from "../types/Promotion";
import { E_PROMOTION } from "../enums/Promotion";
import { transformFilterQueriesToObject } from "../functions/query";

function getPromotionList({ queryParams }: IRequestArgs) {
  const filterQueries = queryParams?.query?.filter;

  const transformQueries = transformFilterQueriesToObject(filterQueries || []);
  const query = {
    sort: queryParams?.query?.sort,
    ...queryParams?.query?.search,
    ...queryParams?.pagination,
    ...transformQueries,
  };
  return request<ListResponseData<IPromotion>>({
    method: ERequestMethods.GET,
    url: E_PROMOTION.LISTING(),
    params: query,
  });
}

function getPromotionActive() {
  const query = {
    sort: {
      createdAt: "DESC",
    },
    limit: 50,
    page: 1,
    filter: {
      status: EPromotionStatus.ACTIVE,
    },
  };
  return request<ListResponseData<IPromotion>>({
    method: ERequestMethods.GET,
    url: E_PROMOTION.LISTING(),
    params: query,
  });
}

function getPromotion(id: string) {
  return request<IResponseData<IPromotion>>({
    method: ERequestMethods.GET,
    url: E_PROMOTION.MAIN(id),
  });
}
function getPromotionByCode(codeName: string) {
  return request<IResponseData<IPromotionDTO>>({
    method: ERequestMethods.GET,
    url: E_PROMOTION.GET_BY_CODE(codeName),
  });
}

function createPromotion(data: ICreatePromotionDTO) {
  return request<IResponseData<IPromotion>>({
    method: ERequestMethods.POST,
    url: E_PROMOTION.LISTING(),
    data,
  });
}

function updatePromotion(id: string, data: Partial<ICreatePromotionDTO>) {
  return request<IResponseData<IPromotion>>({
    method: ERequestMethods.PUT,
    url: E_PROMOTION.MAIN(id),
    data,
  });
}

function deletePromotion(id: string) {
  return request<IResponseData<IPromotion>>({
    method: ERequestMethods.DELETE,
    url: E_PROMOTION.MAIN(id),
  });
}

const PromotionRepository = Object.freeze({
  getPromotionList,
  getPromotion,
  getPromotionByCode,
  createPromotion,
  updatePromotion,
  deletePromotion,
  getPromotionActive,
});

export default PromotionRepository;
